export const isSenderApp =
	import.meta.env.VITE_APP_MODE === 'sender' || import.meta.env.MODE === 'sender';
